import React from 'react';
import classnames from 'classnames';
import Timestamp from '../../../../Timestamp';
import { getThumbGlobalClassNames } from '../../helpers';
var FreeformThumbHtmlView = function (props) {
    var deviation = props.deviation;
    return (React.createElement("div", { style: { width: props.width, height: props.height }, className: classnames('daeditor-freeform-root', getThumbGlobalClassNames(deviation)) },
        React.createElement("div", { className: "daeditor-freeform-header" },
            React.createElement("span", { className: "daeditor-freeform-title" }, deviation.title)),
        React.createElement("div", { className: "daeditor-freeform-body" },
            React.createElement("div", { className: "daeditor-freeform-date" },
                React.createElement(Timestamp, { timestamp: deviation.publishedTime })),
            React.createElement("div", { className: "daeditor-freeform-text" }, deviation.textContent && deviation.textContent.excerpt))));
};
FreeformThumbHtmlView.displayName = 'FreeformThumbHtmlView';
export default FreeformThumbHtmlView;
//# sourceMappingURL=FreeformHtml.js.map